import React from "react";
import { useNavigate } from "react-router-dom";

import { Button } from "@mui/material";

import { Job } from "../../services/api";

const JobRowAction: React.FC<{
  row: Job;
}> = ({ row }) => {
  const navigate = useNavigate();

  return (
    <Button
      sx={{ minWidth: "80px" }}
      size="small"
      variant="contained"
      onClick={() => navigate(`/jobs/${row._id}`)}
    >
      Details
    </Button>
  );
};

export default JobRowAction;
